import Vue from 'vue'
import VueRouter from 'vue-router'

import PageHome from '../views/PageHome.vue'
const PageProjects = () => import('../views/PageProjects.vue')
const PagePublications = () => import('../views/PagePublications')
const PageCredentials = () => import('../views/PageCredentials')
const Page404 = () => import('../views/Page404.vue')

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: PageHome
  },
  {
    path: '/publications',
    name: 'Publications',
    component: PagePublications
  },
  {
    path: '/projects',
    name: 'Projects',
    component: PageProjects
  },
  {
    path: '/credentials',
    name: 'Credentials',
    component: PageCredentials
  },
  {
    path: '*',
    name: 'Page404',
    component: Page404
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
